import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { "data-testid": "helmop-target-tab" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mmt-16 mb-20" }

import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import FleetClusterTargets from '@shell/components/fleet/FleetClusterTargets/index.vue';
import HelmOpTargetOptionsSection from '@shell/components/fleet/HelmOpTargetOptionsSection.vue';

import type { Target } from '@shell/types/fleet';

interface HelmOpValue {
  spec: {
    targets: Target[];
    serviceAccount?: string;
    namespace?: string;
  };
  metadata: { namespace: string };
  targetClusters: object[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HelmOpTargetTab',
  props: {
    value: {},
    mode: {},
    realMode: {},
    targetsCreated: { default: '' },
    hideAdditionalOptions: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  emits: ["update:targets", "targets-created"],
  setup(__props: any, { emit: __emit }) {



// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const updateTargets = (value: Target[]) => {
  emit('update:targets', value);
};

const onTargetsCreated = (value: string) => {
  emit('targets-created', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'gap-6': __props.compact })
    }, [
      (!__props.compact || __props.realMode === 'view')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(t)('fleet.helmOp.target.label')), 1))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      _createVNode(FleetClusterTargets, {
        targets: __props.value.spec.targets,
        matching: __props.value.targetClusters,
        namespace: __props.value.metadata.namespace,
        mode: __props.realMode,
        created: __props.targetsCreated,
        compact: __props.compact,
        "data-testid": "helmop-target-cluster-targets",
        "onUpdate:value": updateTargets,
        onCreated: onTargetsCreated
      }, null, 8, ["targets", "matching", "namespace", "mode", "created", "compact"])
    ], 2),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (!__props.hideAdditionalOptions)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('fleet.helmOp.target.additionalOptions')), 1),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createVNode(HelmOpTargetOptionsSection, {
            value: __props.value,
            mode: __props.mode,
            "data-testid": "helmop-target-options"
          }, null, 8, ["value", "mode"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})